/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from 'react';
import tenantUserServices from '../../../../../services/clientAdmin/tenantUserServices';

const PAGE_SIZE_ASSESSMENT = 8;
const PAGE_SIZE_COURSE = 10;
const PAGE_SIZE_CONTENT = 12;

export const useLearnerData = (userId) => {
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  const [assessments, setAssessments] = useState([]);
  const [assessmentsLoading, setAssessmentsLoading] = useState(true);
  const [assessmentsPage, setAssessmentsPage] = useState(0);
  const [assessmentsTotal, setAssessmentsTotal] = useState(0);

  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const [coursesPage, setCoursesPage] = useState(0);
  const [coursesTotal, setCoursesTotal] = useState(0);

  const [content, setContent] = useState([]);
  const [contentLoading, setContentLoading] = useState(true);
  const [contentPage, setContentPage] = useState(0);
  const [contentTotal, setContentTotal] = useState(0);

  // Fetch profile only on mount
  useEffect(() => {
    if (!userId) return;
    tenantUserServices.getTenantUserById(userId).then((res) => {
      setProfile(res.ok ? res.data : null);
      setProfileLoading(false);
    });
  }, [userId]);

  // Fetch assessments with pagination
  const fetchAssessments = useCallback((page = 0) => {
    setAssessmentsLoading(true);
    tenantUserServices
      .getLearnerAssessmentPerformance(userId, page, PAGE_SIZE_ASSESSMENT)
      .then((res) => {
        if (res.ok) {
          setAssessments(res.data?.assessments || []);
          setAssessmentsTotal(res.data?.total || 0);
          setAssessmentsPage(page);
        } else {
          setAssessments([]);
        }
        setAssessmentsLoading(false);
      });
  }, [userId]);

  // Fetch courses with pagination
  const fetchCourses = useCallback((page = 0) => {
    setCoursesLoading(true);
    tenantUserServices
      .getLearnerCoursePerformance(userId, page, PAGE_SIZE_COURSE)
      .then((res) => {
        if (res.ok) {
          // Extract 'courses' array from response (not 'data')
          setCourses(res.data?.courses || []);
          setCoursesTotal(res.data?.total || 0);
          setCoursesPage(page);
        } else {
          setCourses([]);
        }
        setCoursesLoading(false);
      });
  }, [userId]);

  // Fetch content with pagination
  const fetchContent = useCallback((page = 0) => {
    setContentLoading(true);
    tenantUserServices
      .getLearnerContentAccess(userId, page, PAGE_SIZE_CONTENT)
      .then((res) => {
        if (res.ok) {
          // Extract 'content' array from response (not 'data')
          setContent(res.data?.content || []);
          setContentTotal(res.data?.total || 0);
          setContentPage(page);
        } else {
          setContent([]);
        }
        setContentLoading(false);
      });
  }, [userId]);

  // Initial load on userId change
  useEffect(() => {
    if (!userId) return;
    fetchAssessments(0);
    fetchCourses(0);
    // fetchContent(0);
  }, [userId]);

  const updateProfileStatus = (newStatus) => {
    setProfile((prev) => ({ ...prev, status: newStatus }));
  };

  return {
    profile,
    profileLoading,
    assessments,
    assessmentsLoading,
    assessmentsPage,
    assessmentsTotal,
    fetchAssessments,
    courses,
    coursesLoading,
    coursesPage,
    coursesTotal,
    fetchCourses,
    content,
    contentLoading,
    contentPage,
    contentTotal,
    fetchContent,
    updateProfileStatus,
  };
};